import { registerLazyPopupRenderer } from "@/entities/bottom-popup"

registerLazyPopupRenderer("trust-gate", () => import("../ui/trust-gate-popup"))
